import React, {useEffect, useState, useRef} from 'react';
import dao from '../../dao/authDao';
import authUtils from '../../utils/authUtils';

export const AuthContext = React.createContext({
  loaded: false,
  loggedIn: false,
  ownedFunctionTypes: [],
});

export default function AuthProvider(props) {
  const {children} = props;
  const [loaded, setLoaded] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [ownedFunctionTypes, setOwnedFunctionTypes] = useState([]);
  const loadingRef = useRef(false);

  const init = async () => {
    try {
      if (loadingRef.current) {
        return;
      }
      loadingRef.current = true;
      setLoaded(false);
      const r = await dao.loadAuth();
      setLoggedIn(true);
      setOwnedFunctionTypes(authUtils.getFunctionTypes(r));
    } catch (e) {
      console.error(e);
      setLoggedIn(false);
    } finally {
      loadingRef.current = false;
      setLoaded(true);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return <AuthContext.Provider value={{loaded, loggedIn, ownedFunctionTypes}}>{children}</AuthContext.Provider>;
}
